import React from 'react';
import styled from 'styled-components';
import {
  border3D, width100, dropShadow,
} from '../constants';

const Input = styled.input`
    ${dropShadow}
    ${border3D}
    ${width100}
    height: 4rem;
    max-width: 5rem;
    color: blue;
    border-color: red;
    text-align: center;
    font-size: 3rem;
    margin: 1rem;

  :focus {
    border-color: yellow;
    background: yellow;
  }

  :hover {
    border-color: yellow;
  }
`;


export default function InputComponent(props) {
  // TODO: capitalize
  const { initials, setInitials, index } = props;

  const handleChange = (event) => {
    let newCharacter = event.target.value;
    // console.log(newCharacter);
    if (newCharacter === '') {
      newCharacter = ' ';
    }
    const newInitials = initials.substr(0, index)
     + newCharacter + initials.substr(index + newCharacter.length);
    setInitials(newInitials);
  };

  return (
    <Input onChange={handleChange} maxLength="1" />

  );
}
